import { API_BASE_URL } from './apiConfig.js';
export const getProductImage = (imagePath) => {
    if (!imagePath) return "/autoFill.jpg";

    // Detect if the app incorrectly prefixed a local file with the remote R2 URL
    if (imagePath.includes('r2.dev')) {
        const filename = imagePath.split('/').pop(); 
        
        // If the filename starts with a long timestamp (10+ digits), it's a local upload!
        if (/^\d{10,}/.test(filename)) {
            return `${API_BASE_URL}/images/${filename}`;
        }
    }

    // If it's a standard external URL (old data), return as is
    if (imagePath.startsWith('http')) {
        return imagePath;
    }

    // Default for local filenames
    return `${API_BASE_URL}/images/${imagePath}`;
};